import axios from "axios";
import DriversType from "../../../types/DriversType";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { MissingEquipmentTypes } from "../Types";


const MissingEquipmentServer ={
  get:{
    getAllEquipment:(tenant:string, data:MissingEquipmentTypes.MissingEquipmentFilter & { present?: 'all' | boolean }, serverParams: ServerSideTypes.IParams) => {
      const { present, ...restData } = data;
      const params: any = {
        tenant,
        ...restData,
        ...serverParams,
      };
      if (present !== 'all') {
        params.present = present;
      }
      return axios.get<ServerSideTypes.IResult<any>>("./masterdatadamage/equipments/byfilters",{params }).then(
        response => response.data,
      )
    },
    getEquipment:(tenant:string)=>{
      return axios.get<any>("./masterdatadamage/damageform/geteqlist", {params:{tenants:tenant}}).then(response =>response.data)
    },
    export:(tenant:string,data:any)=>{
      return axios.get("./masterdatadamage/equipments/exportexcel",{params:{tenant,...data},responseType:"arraybuffer"});
    }
  },
}

export default MissingEquipmentServer;